import { API_BASE_URL } from "../apiConfig";

export async function getCompletedPaperResult(
  resultId
) {
  const token = localStorage.getItem(
    "chemMasterToken"
  );

  if (!token) {
    throw new Error(
      "Your login session could not be found."
    );
  }

  const response = await fetch(
    `${API_BASE_URL}/results/${resultId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message ||
      "The completed paper could not be loaded."
    );
  }

  return data;
}
